export enum OperationUserStatus {
    NEW = 'NEW',
    SUCCESS = 'SUCCESS',
    PROCESSED = 'PROCESSED',
    EXPIRED = 'EXPIRED',
    EXTENDED = 'EXTENDED'
}
